document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('profileDropdownToggle');
    const menu   = document.getElementById('profileDropdownMenu');

    if (!toggle || !menu) return;

    function closeMenu() {
        menu.classList.add('hidden');
        menu.classList.remove('open');
    }

    function openMenu() {
        menu.classList.remove('hidden');
        menu.classList.add('open');
    }

    toggle.addEventListener('click', function (e) {
        e.stopPropagation();

        if (menu.classList.contains('hidden')) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    document.addEventListener('click', function () {
        if (!menu.classList.contains('hidden')) {
            closeMenu();
        }
    });
});
